// 约定一个通用的键名
const INFO_KEY = 'mymxqh_user_info'
const MY_GOODS_LIST = 'mymxqh_my_goods_list'
const MY_COLLECTION_LIST = 'mymxqh_my_collection_list'
const MY_GOSSIP_LIST = 'mymxqh_my_gossip_list'
const MY_TASK_LIST = 'mymxqh_my_task_list'
const MY_RENT_LIST = 'mymxqh_my_rent_list'
const MY_GAME_DATA_LIST = 'mymxqh_my_game_data_list'
export const getInfo = () => {
  const defaultObj = { user: { id: '', authorization: '' } }
  const result = localStorage.getItem(INFO_KEY)// 这个值有可能是空，不能直接JSON.parse
  return result ? JSON.parse(result) : defaultObj
}
export const setInfo = (obj) => {
  localStorage.setItem(INFO_KEY, JSON.stringify(obj))
}
export const removeInfo = () => {
  localStorage.removeItem(INFO_KEY)
}
export const setMyGoodsList = (obj) => {
  localStorage.setItem(MY_GOODS_LIST, JSON.stringify(obj))
}
export const getMyGoodsList = () => {
  const defaultObj = []
  const result = localStorage.getItem(MY_GOODS_LIST)// 这个值有可能是空，不能直接JSON.parse
  return result ? JSON.parse(result) : defaultObj
}
export const setMyCollectionList = (obj) => {
  localStorage.setItem(MY_COLLECTION_LIST, JSON.stringify(obj))
}
export const getMyCollectionList = () => {
  const defaultObj = []
  const result = localStorage.getItem(MY_COLLECTION_LIST)// 这个值有可能是空，不能直接JSON.parse
  return result ? JSON.parse(result) : defaultObj
}

export const setMyGossipList = (obj) => {
  localStorage.setItem(MY_GOSSIP_LIST, JSON.stringify(obj))
}
export const getMyGossipList = () => {
  const defaultObj = []
  const result = localStorage.getItem(MY_GOSSIP_LIST)// 这个值有可能是空，不能直接JSON.parse
  return result ? JSON.parse(result) : defaultObj
}

export const setMyTaskList = (obj) => {
  localStorage.setItem(MY_TASK_LIST, JSON.stringify(obj))
}
export const getMyTaskList = () => {
  const defaultObj = []
  const result = localStorage.getItem(MY_TASK_LIST)// 这个值有可能是空，不能直接JSON.parse
  return result ? JSON.parse(result) : defaultObj
}

export const setMyRentList = (obj) => {
  localStorage.setItem(MY_RENT_LIST, JSON.stringify(obj))
}
export const getMyRentList = () => {
  const defaultObj = []
  const result = localStorage.getItem(MY_RENT_LIST)// 这个值有可能是空，不能直接JSON.parse
  return result ? JSON.parse(result) : defaultObj
}

export const setMyGameDataList = (obj) => {
  localStorage.setItem(MY_GAME_DATA_LIST, JSON.stringify(obj))
}
export const getMyGameDataList = () => {
  const defaultObj = []
  const result = localStorage.getItem(MY_GAME_DATA_LIST)// 这个值有可能是空，不能直接JSON.parse
  return result ? JSON.parse(result) : defaultObj
}
